<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >在线文档</span>
    </div>
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'payStatus/notify';
export default {
  components: { onlineDoc },
  data() {
    return {
      mainStatus: "online",
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        apiDesc: "接入方订单支付状态更新时，同步极兔",
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        postDataList:[
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: "接入方在平台的api账户标识"},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: "签名字符串"},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: "时间戳，毫秒"},
                  ]
            },
            {
                title:'请求参数',
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: "业务参数",describe: "业务参数模块内json格式的string类型"},
                  ]
            },
            {
              title:"业务参数",
              value:[
                {name: "txlogisticId",type: "String",require: "Y",normal: "",describe: "客户订单编号"},
                {name: "billCode",type: "String",require: "Y",normal: "",describe: "极兔运单编号"},
                {name: "orderPayStatus",type: "String",require: "Y",normal: "0",describe: '订单支付状态：0、"支付成功"'},
                {name: "time",type: "String",require: "N",normal: "2026-05-07 10:35:39",describe: "支付时间：yyyy-MM-dd HH:mm:ss"},
              ]
            }
        ],
        responseDataList:[
            {
                title:'响应参数',
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: "返回码，见附录"},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: "描述"},
                  ]
            }
        ],
        requestCode: `Header：
    apiAccount=178337126125932605
    digest=wf7biAijVtFVqCNlqJX8lA==
    timestamp=1743649137211

Body：
    bizContent={"txlogisticId":"10000936186044","billCode":"UT0000741366371","orderPayStatus":"0","time":"2026-05-07 10:35:39"}`,
        responseCode: JSON.parse(
          `{
  "code": "1",
  "msg": "success"
}`
        ),
        errcodeJson: [
          {code:'1450033329',msg:"支付状态通知异常"},
          {code:'1450033330',msg:"支付状态不合法"}
        ]
      }
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>
